/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const ajaxHttp = require('appUtil/ajaxHttp');
const tip = require('components/base/pop/tip');
const { apiPath } = require('appService/api');

require('./add-edit-integral.scss');
const template = require('./add-edit-integral.tpl');

const EditIntegralEvent = {
	name: "edit-integral-event",

	template,

	data() {
		return {
			headName: "编辑积分事件",
			addEditUrl: apiPath.user.editIntegralEvent,
			beforeSubmit() {}
		}
	},

	ready() {
		this.getIntegralById();
	},

	methods: {
		getIntegralById() {
			let url = apiPath.user.getIntegralById;
			let queryParams = {
				"integralId": this.$route.query.integralId
			};
			ajaxHttp(url, {
				"data": queryParams
			}).then((res) => {
				this.$refs.integrlInputbox.val(res.data.integralName);
				this.$refs.scoreInputbox.val(res.data.score);
				this.$refs.limitInputbox.val(res.data.dayLimit);
				this.$refs.stateCheckbox.val(res.data.state);
			}).catch((res) => {
				tip(res.error);
			})
		},
		submit() {
			if(this.$refs.formArea.verify()) {
				this.$refs.addeditPop.show();
			}
			this.beforeSubmit = (queryOpt) => {
				queryOpt.integralId = this.$route.query.integralId;
			}
		},
		saveMessage() {
			this.$refs.formArea.submit()
		},
		success(res) {
			if(res.code === 0) {
				this.$refs.successPop.show();
			} else {
				tip(res.error);
			}
		},
		goRoute() {
			this.$refs.successPop.hide();
			this.$refs.addeditPop.hide();
			this.$route.router.go({
        path: "/page/user/integral-event/"
      })
		}
	}
}

module.exports = EditIntegralEvent;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/user/integral-event/add-edit-integral/edit-integral-event.js